export enum CustomPaymentStep {
    PaymentInfo = 'PaymentInfo',
    Checkout = 'Checkout',
    Finished = 'Finished',
}
